import {
    SET_COMMON_ERROR
} from "./CommonErrorHandlerType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_COMMON_ERROR:
           return {
                ...state,
                commonApiError: action.commonApiError,
            };
        default:
            return state;
    };
}

export default reducer;  